export const ASSESSMENT_POLLING_STORAGE_KEY = "assessmentPollingIds";
export const TERMINAL_ASSESSMENTS_STORAGE_KEY = "terminalAssessmentIds";

export const getPollingIds = (): string[] => {
  try {
    const raw = localStorage.getItem(ASSESSMENT_POLLING_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const setPollingIds = (ids: string[]) => {
  try {
    const uniqueIds = Array.from(new Set(ids.filter(Boolean)));
    localStorage.setItem(
      ASSESSMENT_POLLING_STORAGE_KEY,
      JSON.stringify(uniqueIds)
    );
  } catch {
    // no-op
  }
};

export const addPollingIds = (idsToAdd: string[] | string) => {
  const current = getPollingIds();
  const toAdd = Array.isArray(idsToAdd) ? idsToAdd : [idsToAdd];
  setPollingIds([...current, ...toAdd]);
};

export const removePollingId = (idToRemove: string) => {
  const current = getPollingIds();
  setPollingIds(current.filter((id) => id !== idToRemove));
};

// Terminal assessment tracking (completed/exception/irrelevant)
export const getTerminalAssessmentIds = (): string[] => {
  try {
    const raw = localStorage.getItem(TERMINAL_ASSESSMENTS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const addTerminalAssessmentId = (id: string) => {
  try {
    const current = getTerminalAssessmentIds();
    const uniqueIds = Array.from(new Set([...current, id]));
    localStorage.setItem(
      TERMINAL_ASSESSMENTS_STORAGE_KEY,
      JSON.stringify(uniqueIds)
    );
  } catch {
    // no-op
  }
};

export const isTerminalAssessment = (id: string): boolean => {
  const terminalIds = getTerminalAssessmentIds();
  return terminalIds.includes(id);
};
